import React, { useContext, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useGet } from 'restful-react'
import { ApiError, QuotationRequest } from 'EstraSuppliers'
import { endpoints } from 'app/api/endpoints'
import { routes } from 'app/routes'
import { HeaderContext } from 'app/Contexts/HeaderProvider'
import styled from 'styled-components'
import { Button } from 'app/components/ui/Button'
import { QuotationCard } from './QuotationCard'
import { QuotationBox } from './QuotationBox'
import { Container } from 'app/components/ui/Container'
import { Base } from 'app/components/ui/Base'
import { LoadingSpinner } from 'app/components/ui/LoadingSpinner'
import { themeEstra } from 'app/styles/themeEstra'
import { Text } from 'app/components/ui/Text'

import { QuotationChat } from './QuotationChat'

export const QuotationDetail: React.FC = () => {
  const headerCtx = useContext(HeaderContext)

  const headerTitle = 'Richiesta Preventivo'

  useEffect(() => {
    // Set title of header, subtitle will be updated when data is laoded
    if (headerCtx) headerCtx.updateTitles(headerTitle)
  }, [])

  const { quotationId } = useParams<typeof routes.quotation.exampleParams>()

  // API FETCH
  const { data: quotation, loading, refetch: refetchQuotation } = useGet<
    QuotationRequest,
    ApiError
  >({
    path: `${endpoints.quotationDetail}/${quotationId}`,
  })

  useEffect(() => {
    if (headerCtx && quotation) {
      if (headerCtx) headerCtx.updateSubTitle(quotation.name)
      headerCtx.updateSubtitleVariant('quotation_detail')
    }
  }, [quotation])

  if (loading) {
    return <LoadingSpinner />
  }

  if (!quotation) {
    return (
      <Container>
        <QuotationNotFoundWrapper>
          <Text variant='s20' color={themeEstra.color.primari.grigioEstra}>
            Richiesta di preventivo non trovata
            <LinkWrapper>
              <Button to={routes.dashboard.makeUrl()}>Torna alla Home</Button>
            </LinkWrapper>
          </Text>
        </QuotationNotFoundWrapper>
      </Container>
    )
  }

  return (
    <>
      <StyledBase
        paddingTop={1}
        bgImage='https://res.cloudinary.com/estra/image/upload/v1612197984/estra20dev/area_fornitori/quotation_detail/quotation_box_bg.svg'
      >
        <QuotationDetailContainer>
          <Grid>
            <QuotationCardColumn>
              <QuotationCard quotation={quotation}></QuotationCard>
            </QuotationCardColumn>
            <div>
              <QuotationBox
                quotation={quotation}
                refetchQuotation={refetchQuotation}
              ></QuotationBox>
              <div>
                <Text variant='s20' weight='700' mb={2}>
                  Vuoi scrivere qualcosa a proposito del {'\n'}
                  preventivo al responsabile aziendale? Fallo qui.
                </Text>
                <QuotationChat quotationRequest={quotation}></QuotationChat>
              </div>
            </div>
          </Grid>
        </QuotationDetailContainer>
      </StyledBase>
    </>
  )
}

const StyledBase = styled(Base)`
  @media (max-width: ${({ theme }) => theme.bp.desktop}) {
    background-image: none;
  }
`

const QuotationDetailContainer = styled(Container)``
const LinkWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 3rem;
`

const QuotationNotFoundWrapper = styled.div`
  max-width: 450px;
  margin-left: auto;
  margin-right: auto;

  display: flex;
  align-items: center;
  justify-content: center;
`

const Grid = styled.div`
  padding-top: 3rem;

  @media (max-width: ${({ theme }) => theme.bp.desktop}) {
    max-width: 600px;
    margin-right: auto;
    margin-left: auto;
  }

  @media (min-width: ${({ theme }) => theme.bp.desktop}) {
    display: grid;
    grid-template-columns: 2fr 2fr;
    gap: 4rem;
  }
`

const QuotationCardColumn = styled.div`
  @media (max-width: ${({ theme }) => theme.bp.desktop}) {
    margin-bottom: 6rem;
  }
`
